const MAX_ATTEMPTS = 5

const wait = interval => new Promise(resolve => setTimeout(resolve, interval))

// Отримує асинхронну функцію, яку буде перезапускати з заданим інтревалом,
// якщо при виконанні переданої функції станеться помилка
const retryPromise = async (fn, retriesLeft = MAX_ATTEMPTS, interval = 3000) => {
	try {
		const res = await fn()
		return res
	} catch (error) {
		await wait(interval)

		if (retriesLeft === 0) throw new Error(error)

		return await retryPromise(fn, retriesLeft - 1, interval)
	}
}

// Обгортка над звичайною функцією, щоб зробити її такою, що сама перезапускається
const createAutoRerunFunctionIfFailed = (fn, attemptLimit, delay) => {
	return async (...args) =>
		await retryPromise(async () => await fn(...args), attemptLimit, delay)
}

export default createAutoRerunFunctionIfFailed
